import styled from 'styled-components';

export const Container = styled.div`
  width: 35px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
